<template>
    <transition name="fade">

        <div class="vue-modal" v-show="open">
            <transition name="drop-in">
                <div class="vue-modal-inner" v-show="open">
                    <div class="vue-modal-content shadow-lg" style="min-width: 600px; background-color: var(--form-color); color: var(--theme-text-main); border-radius: 15px; padding: 30px;">
                        <slot />
                        <p class="h3 fw-bold" style="color: var(--theme-text-main); text-align: center; margin-bottom: 20px;">Please Enter Customer's
                            <span v-if="type == 'customer_tin'">
                                TIN Number
                            </span>
                            <span v-else-if="type == 'phone'">
                                Phone Number
                            </span>
                            <span v-else-if="type == 'name'">
                                Name
                            </span>
                        </p>
                        
                        <div class="form-group mb-3">
                            <input type="text" name="customer_key_value" v-on:keyup.enter="checkLoiality()" class="form-control input-lg" id="customer_key_value" v-model="customer_key_value" style="font-size: 1.2em; background: rgba(0,0,0,0.2); border: 1px solid rgba(255,255,255,0.1); color: var(--theme-text-main); text-align: center;" />
                        </div>

                        <div style="display:flex; justify-content: center; gap: 30px; margin-bottom: 20px;">
                            <div style="display: flex; align-items: center;">
                                <input id="tin" type="radio" name="type" @click="setType('customer_tin')" :checked="type == 'customer_tin'" style="transform: scale(1.5); margin-right: 10px; cursor: pointer;">
                                <label for="tin" title="Tin" style="font-size:1.3em; margin:0; cursor: pointer;">Tin</label>
                            </div>
                            <div style="display: flex; align-items: center;">
                                <input id="phone" type="radio" name="type" @click="setType('phone')" :checked="type == 'phone'" style="transform: scale(1.5); margin-right: 10px; cursor: pointer;">
                                <label for="phone" title="Phone" style="font-size:1.3em; margin:0; cursor: pointer;">Phone</label>
                            </div>
                            <div style="display: flex; align-items: center;">
                                <input id="name" type="radio" name="type" @click="setType('name')" :checked="type == 'name'" style="transform: scale(1.5); margin-right: 10px; cursor: pointer;">
                                <label for="name" title="Name" style="font-size:1.3em; margin:0; cursor: pointer;">Name</label>
                            </div>
                        </div>

                        <div style="display:flex; justify-content: space-between; margin-top: 20px; border-top: 1px solid rgba(255,255,255,0.1); padding-top: 20px;">
                            <button @click="close" class="btn btn-danger btn-lg" style="min-width: 120px; font-size: 1.2em;">Close</button>
                            <button @click="checkLoiality()" class="btn btn-success btn-lg" style="min-width: 120px; font-size: 1.2em;">Ok</button>
                        </div>

                    </div>
                </div>
            </transition>
            <div class="col-sm-4" style="position:fixed;width:245px;height:300px; min-height: 200px;left:0px;bottom:-80px;color: var(--theme-text-main);margin-left: -10px;margin-right: -10px;">
                <numericpad :onInput="onInput" :onDelete="onDelete" :onReset="onReset" :show="showKeypad"/>
            </div>
        </div>
    </transition>
</template>
<script>
import numericpad from "@/components/SimpleKeyboard";
import axios from "axios";
import commonServices from "@/shared/commonServices"

export default {
    name:"Loiality",
    components:{ numericpad },
    mixins: [commonServices],
    mounted() {
        this.customer_key_value = '';
        this.$el.querySelector('#customer_key_value').focus = true;
    },
    
    data: function(){
        return {
            customer_key_value: '',
            type: 'customer_tin',
            loiality: null,
            showKeypad: true,
        }
    },
    methods:{
        onInput(key) {
            if(key == 11){
                this.customer_key_value = (this.customer_key_value + "0");
            }else{
                this.customer_key_value = (this.customer_key_value + key);
            }
        },
        onDelete() {
            this.customer_key_value = this.customer_key_value.slice(0, this.customer_key_value.length - 1);
        },
        onReset() {
            this.customer_key_value = "";
        },
        setType(type_selected){
            
            this.type = type_selected;
        },
        passLoialityPoints()
        {
            this.customer_key_value = '';
            this.$emit('getLoialityPoints', this.loiality)
        },
        checkLoiality: async function(){
            try{

                //Loyality API
                let dataURL = this.apiURL+'Loyalty/checkLoyalty';
                let loialityJson = {"appId":localStorage.appId, 'cardnumber': this.customer_key_value, 'type': this.type};
                //let dataURL = this.apiURL+'Loyalty/getCustomerById';
                //let loialityJson = {"appId":localStorage.appId, 'customerId': "18"};
                let response = await axios.post(dataURL, loialityJson); 
                if(response.data.status == 'error'){
                    
                }
                this.loiality = response.data;

                this.passLoialityPoints()
            }
            catch (error){
                console.log(error);
            }
            this.close();
        }
    },
    props:{
        open: {
            type:Boolean,
            required:true
        },
    },
    setup(_, { emit }){
        const close = () => {
            emit('close');
        };

        return { close };
    },
};
</script>
<style scoped>
*,
::before

::after{
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}
.vue-modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    background-color: rgba(0, 0, 0, 0.4);
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 1rem;
}
.vue-modal-inner {
    max-width: 90%;
    max-height: 90vh;
    margin: 0;
}
.vue-modal-content {
    position: relative;
    background-color: #fff;
    border: 5px solid rgba(0, 0, 0, 0.3);
    background-clip: padding-box;
    border-radius: 1rem;
    padding: 1rem;
    width: 600px;
    height: auto;
    max-height: 90vh;
    overflow: auto;
}
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}
.drop-in-enter-active,
.drop-in-leave-active {
    transition: all 0.3s ease-out;
}
.drop-in-enter-from,
.drop-in-leave-to {
    opacity: 0;
    transform: translateY(50px);
}

</style>
